import React from 'react';

export const SelectLabel = ({ 
  labelText, 
  showSemicolon, 
  style 
}) => {
  if (!labelText) return null;

  return (
    <label style={style}>
      {labelText}{showSemicolon ? ':' : ''}
    </label>
  );
};